import { Minus, Plus } from "lucide-react";

export default function QuantitySelector({ value, onChange, max = 10 }) {
  return (
    <div>
      <p className="mb-3 text-sm font-medium">Quantity</p>
      <div className="inline-flex items-center rounded-full border border-border">
        <button
          type="button"
          onClick={() => onChange(Math.max(1, value - 1))}
          className="p-3 focus:outline-none focus:ring-2 focus:ring-ring"
        >
          <Minus className="size-4" />
        </button>
        <span className="min-w-10 text-center text-sm font-medium">{value}</span>
        <button
          type="button"
          onClick={() => onChange(Math.min(max, value + 1))}
          className="p-3 focus:outline-none focus:ring-2 focus:ring-ring"
        >
          <Plus className="size-4" />
        </button>
      </div>
    </div>
  );
}